import angular from 'angular';
import { confirmDialog, alerts } from 'app/components/global';
import {
  ssDialogService,
  orgDataService,
  userService
} from 'app/services';
import editBankLogoDialog from '../editLogoDialog';
import controller from './edit-customer-logo.directive.controller';
import directive from './edit-customer-logo.directive';


export default angular.module('app.components.admin.customerAdministration.editCustomerLogo', [
  alerts,
  confirmDialog,
  orgDataService,
  ssDialogService,
  userService,
  editBankLogoDialog
])
  .directive('caEditCustomerLogo', directive)
  .controller('CAEditCustomerLogoDirectiveController', controller)
  .name;

console.log('app.components.admin.customerAdministration.editCustomerLogo created');
